import Vue from 'vue'

import ActionDialog from './components/ActionDialog'
import Pagination from './components/Pagination'
import Autocomplete from './components/Autocomplete'
import PrintButton from './components/PrintButton'
import DeleteButton from './components/DeleteButton'
import EditButton from './components/EditButton'
import SearchButton from './components/SearchButton'

Vue.component('action-dialog', ActionDialog)
Vue.component('v-pagination', Pagination)
Vue.component('autocomplete', Autocomplete)
Vue.component('print-btn', PrintButton)
Vue.component('delete-btn', DeleteButton)
Vue.component('edit-btn', EditButton)
Vue.component('search-btn', SearchButton)